import PurchaseSubscriptionDialog from "@/dialogs/purchase-subscription-dialog";
import { store } from "@store";
import { openDialog } from "@store/dialogs";

export const openStarterDialog = (source: string) => {
  store.dispatch(
    openDialog({
      id: "purchase-subscription",
      content: PurchaseSubscriptionDialog,
      props: { source, plan: "starter", period: "annually" },
    }),
  );
};
